// 权限指令
import { usePermissionStore } from '@/store/permission'

export default {
  mounted(el, binding) {
    const requiredPermission = binding.value

    // 如果没有指定权限，则不做处理
    if (!requiredPermission) {
      return
    }

    const permissionStore = usePermissionStore()
    const hasPermission = permissionStore.hasPermission(requiredPermission)

    // 如果没有权限，则移除元素
    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}
